import { render, staticRenderFns } from "./ReachabilityOrganisation.vue?vue&type=template&id=6ebd8534&"
import script from "./ReachabilityOrganisation.vue?vue&type=script&lang=js&"
export * from "./ReachabilityOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports